module.exports = __webpack_public_path__ + "static/img/bg42.2007ac65.png";